module.exports = __webpack_public_path__ + "img/Monte_Kope_120.716f2a83.jpg";